<template>
  <section class="section-wrapp">
    <Breadcrumbs v-if="breadcrumbsData !== null" v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    <section class="section-graph-title">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h1 class="graph-title">{{ title }}</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="section-graph">
      <div class="container-fluid">
        <div v-if="station !== null" class="row">
          <Temperature :station="station"></Temperature>
          <Insolation :station="station"></Insolation>
          <PanelTemperature :station="station"></PanelTemperature>
        </div>
        <div class="row">
          <div class="col-12 weather-item-col-graph">
            <Graph v-if="station !== null" :station="station"></Graph>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import Graph from '@/components/weather/Graph'
import Temperature from '@/components/weather/panels/Temperature'
import Insolation from '@/components/weather/panels/Insolation'
import PanelTemperature from '@/components/weather/panels/PanelTemperature'

export default {
  name: 'Weather',
  components: {
    Breadcrumbs, Graph, Temperature, Insolation, PanelTemperature
  },
  data() {
    return {
      station: null,
      title: '',
      breadcrumbsData: null
    }
  },
  created() {
    let id = this.$route.params.id

    this.$store.dispatch('station/findOne', id).then((station) => {
      this.station = station

      this.breadcrumbsData = [
        {
          url: '/station-view/' + station.id,
          title: station.title
        },
        {
          url: '#',
          title: station.title + ' (Weather)'
        }
      ]
      this.title = station.title + ' (' + station.totalPower + ' MW)'
    }).catch(e => {
      console.log('Got transfer error: ' + e.message)
    })

    this.pollData()
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  methods: {
    pollData() {
      const id = this.$route.params.id

      this.$store.dispatch('station/loadLastData', id)

      this.polling = setInterval(() => {
        this.$store.dispatch('station/loadLastData', id)
      }, 60 * 1000)
    }
  }
}
</script>
